module.exports = __webpack_public_path__ + "static/n-scale-model-railroading-a561a5738ee9ab0250828192c80bc74c.jpg";